<template>
    <div class="condition-item" :key="data.cid">
        <div class="group-wrap">
            <el-form :inline="true" label-width="0" size="mini">
                <div class="mb4">
                    <el-form-item>
                        <CustomInput>
                            <template v-if="actionMonitorField.cost_type" slot="append">
                                <el-select 
                                    style="width: 80px"
                                    :disabled="isView"
                                    :value="data.monitor_data.cost_type || 'cost'" 
                                    placeholder="请选择"
                                    @change="changeCostType"
                                >
                                    <el-option v-for="item in costTypeList" :key="item.value" :value="item.value" :label="item.label"/>
                                </el-select>
                            </template>
                              <el-cascader
                                popper-class="cascader-list-height-300"
                                placement="bottom-start"
                                ref="monitorField"
                                :value="data.monitor_data.field"
                                :options="monitorConditionOptions"
                                @change="changeMonitorCondition"
                                :props="{value:'name',label:'display_name',emitPath:false,expandTrigger: 'hover',}"
                                :filterable="true"
                                :disabled="isView"
                                v-label="{title:'监控项：',color:'#016FA0'}">
                                <template slot-scope="{ node, data }">
                                    <template v-if="(data.config||{}).title">
                                        <span>{{data.display_name}}</span>
                                        <el-tooltip class="item" effect="dark" :content="data.config.title" placement="top">
                                            <i class="el-icon-question pointer ml4 text-color-normal" ></i>
                                        </el-tooltip>
                                    </template>
                                    <span v-else>{{ data.display_name }}</span>
                                </template>
                            </el-cascader>
                        </CustomInput>
                      
                    </el-form-item>

                    <el-form-item v-show="(data.monitor_data.field&&curMonitorConfig.condition_type=='data_1')">
                        <el-select
                            key="range_time_type"
                            :value="data.monitor_data.range_time_type"
                            @change="changeMonitorRangeTimeType"
                            v-label="{title:'时间范围：',color:'#016FA0'}"
                            :disabled="isView"
                            placeholder="请选择">
                            <el-option
                                v-for="item in timeRangeConfigKeys"
                                :key="item"
                                :label="curMonitorConfig.time_range[item]"
                                :disabled="item=='1'&&!actionMonitorField.same_day_segment"
                                :value="item"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :error="getError('monitor_data.range_time')" v-show="(data.monitor_data.field&&curMonitorConfig.condition_type=='data_1')">
                        <el-input-number
                            v-if="data.monitor_data.range_time_type=='2'"
                            @input="changeMonitorRangeTimeN"
                            :value="data.monitor_data.range_time_n"
                            :controls="false"
                            :disabled="isView"
                            class="ml2" style="width: 120px;"
                            placeholder="输入天数"></el-input-number>
                        <template v-else-if="data.monitor_data.range_time_type=='3'">
                            <el-input-number
                                :value="data.monitor_data.range_time_n"
                                @input="changeMonitorRangeTimeN"
                                :controls="false"
                                :disabled="isView"
                                class="ml2"
                                style="width: 90px;" placeholder="输入天数">
                            </el-input-number>
                             -
                            <el-input-number
                                :value="data.monitor_data.range_time_n1"
                                @input="changeMonitorRangeTimeN1"
                                :controls="false"
                                :disabled="isView"
                                class="ml2" style="width: 90px;"
                                placeholder="请输入天数"></el-input-number>
                        </template>
                        <template v-else-if="data.monitor_data.range_time_type=='4'">
                            <el-input-number
                                :value="data.monitor_data.range_time_n"
                                @input="changeMonitorRangeTimeN"
                                :controls="false"
                                :disabled="isView"
                                class="ml2"
                                style="width: 90px;" placeholder="输入天数">
                            </el-input-number>
                            - <span class="normal-text">当日</span>
                        </template>
                    </el-form-item>

                    <el-form-item v-show="data.monitor_data.field&&curMonitorConfig.condition_type=='data_1'&&isCompleteMonitorRangeTimeType">
                        <el-select
                            :value="data.monitor_data.data_method"
                            :disabled="data.monitor_data.range_time_type=='1'||data.monitor_data.range_time_type=='2'||isView"
                            v-label="{title:'数据统计方式：',color:'#016FA0'}"
                            @change="changeMonitorDataMethod"
                            placeholder="请选择">
                            <!-- 1-累计，2-日均，3-每日 -->
                            <el-option v-for="(value,label) in curMonitorConfig.data_method" :label="value" :value="label" :key="label"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-show="data.monitor_data.field&&((data.monitor_data.data_method&&curMonitorConfig.condition_type=='data_1')||curMonitorConfig.condition_type!='data_1')&&isCompleteMonitorRangeTimeType">
                        <el-select
                            :value="data.operator"
                            v-label="{title:'运算符：',color:'#016FA0'}"
                            :disabled="isView"
                            @change="changeOperator"
                            placeholder="请选择">
                            <el-option v-for="(value,label) in curMonitorConfig.operator" :label="value" :value="label" :key="value"></el-option>
                        </el-select>
                    </el-form-item>
                </div>

                <!--监控项：数据统计方式为每日时，只能选对比固定值+KPI指标-->
                <div>
                    <template v-if="data.monitor_data.condition_type!='text'&&data.monitor_data.field&&data.operator">
                        <el-form-item v-show="data.monitor_data.field&&curMonitorConfig.condition_type!='text'&&isCompleteMonitorRangeTimeType">
                            <CustomInput>
                                <template v-if="actionComparativeField.cost_type" slot="append">
                                    <el-select 
                                        style="width: 80px"
                                        :disabled="isView"
                                        :value="data.comparative_data.cost_type || 'cost'" 
                                        placeholder="请选择"
                                        @change="changeCostType"
                                    >
                                        <el-option v-for="item in costTypeList" :key="item.value" :value="item.value" :label="item.label"/>
                                    </el-select>
                                </template>
                                <el-cascader
                                    popper-class="cascader-list-height-300"
                                    placement="bottom-start"
                                    ref="comparativeField"
                                    :value="data.comparative_data.id"
                                    :options="comparativeConditionOptions"
                                    @change="changeComparativeCondition"
                                    :props="{value:'id',label:'display_name',emitPath:false,expandTrigger: 'hover',}"
                                    :filterable="true"
                                    :clearable="false"
                                    :disabled="isView"
                                    v-label="{title:'对比项：',color:'#A36717'}">
                                    <template slot-scope="{ node, data }">
                                        <template v-if="(data.config||{}).title">
                                            <span>{{data.display_name}}</span>
                                            <el-tooltip class="item" effect="dark" :content="data.config.title" placement="top">
                                                <i class="el-icon-question pointer ml4 text-color-normal" ></i>
                                            </el-tooltip>
                                        </template>
                                        <span v-else>{{ data.display_name }}</span>
                                    </template>
                                </el-cascader>
                            </CustomInput>
                        </el-form-item>
                        <el-form-item v-show="data.comparative_data.field&&curComparativeConfig.condition_type=='data_1'&&!isCompareKpiData">
                            <el-select
                                :value="data.comparative_data.range_time_type"
                                @change="changeComparativeRangeTimeType"
                                v-label="{title:'时间范围：',color:'#A36717'}"
                                :disabled="isView"
                                placeholder="请选择">
                                <el-option
                                    v-for="item in timeRangeConfigKeys"
                                    :key="item"
                                    :label="curMonitorConfig.time_range[item]"
                                    :disabled="item=='1'&&!actionMonitorField.same_day_segment"
                                    :value="item"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item :error="getError('comparative_data.range_time')" v-show="data.comparative_data.field&&curComparativeConfig.condition_type=='data_1'&&!isCompareKpiData">
                            <el-input-number
                                v-if="data.comparative_data.range_time_type=='2'"
                                @input="changeComparativeRangeTimeN"
                                :value="data.comparative_data.range_time_n"
                                :controls="false"
                                :disabled="isView"
                                class="ml2" style="width: 120px;"
                                placeholder="请输入天数"></el-input-number>
                            <template v-else-if="data.comparative_data.range_time_type=='3'">
                                <el-input-number
                                    :value="data.comparative_data.range_time_n"
                                    @input="changeComparativeRangeTimeN"
                                    :controls="false"
                                    :disabled="isView"
                                    class="ml2"
                                    style="width: 90px;"
                                    placeholder="请输入天数"></el-input-number>
                                -
                                <el-input-number
                                    :value="data.comparative_data.range_time_n1"
                                    @input="changeComparativeRangeTimeN1"
                                    :controls="false"
                                    :disabled="isView"
                                    class="ml2" style="width: 90px;"
                                    placeholder="请输入天数"></el-input-number>
                            </template>
                            <template v-else-if="data.comparative_data.range_time_type=='4'">
                                <el-input-number
                                    :value="data.comparative_data.range_time_n"
                                    @input="changeComparativeRangeTimeN"
                                    :controls="false"
                                    :disabled="isView"
                                    class="ml2"
                                    style="width: 90px;"
                                    placeholder="请输入天数"></el-input-number>
                                - <span class="normal-text">当日</span>
                            </template>
                        </el-form-item>
                        <el-form-item v-show="data.monitor_data.field&&curComparativeConfig.condition_type=='data_1'&&isCompleteComparativeRangeTimeType&&!isCompareKpiData">
                            <el-select
                                :value="data.comparative_data.data_method"
                                :disabled="data.comparative_data.range_time_type=='1'||data.comparative_data.range_time_type=='2'||isView"
                                v-label="{title:'数据统计方式：',color:'#A36717'}"
                                @change="changeComparativeDataMethod"
                                placeholder="请选择">
                                <!-- 1-累计，2-日均，3-每日 -->
                                <el-option v-for="(value,label) in curMonitorConfig.data_method" :label="value" :value="label" :key="value"></el-option>
                            </el-select>
                        </el-form-item>
                        <template v-if="isCompareKpiData">
                            <el-form-item v-show="data.comparative_data.field">
                                <el-select
                                    :value="data.comparative_data.delivery_scene"
                                    @change="changeComparativeDeliveryScene"
                                    v-label="{title:'kpi维度（场景）：',color:'#A36717'}"
                                    :disabled="isView"
                                    placeholder="请选择">
                                    <el-option
                                        v-for="(value,label) in curMonitorConfig.delivery_scene||deliverySceneMap"
                                        :key="value"
                                        :label="value"
                                        :disabled="isView"
                                        :value="label"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item v-show="data.comparative_data.field&&data.comparative_data.delivery_scene">
                                <div class="info-text" v-if="kpiLoading">
                                    <p class="text-color-gray font12px mt4">验证中，请稍后... <i class="el-icon-loading text-color-primary"></i></p>
                                </div>
                                <div v-else-if="kpiData.isHasKPI">
                                    <p class="text-normal font12px mt4">
                                        筛选的产品KPI均已录入，很棒👍
                                        <span class="text-color-primary pointer font12px ml20" @click="()=>checkKpiData()">刷新</span>
                                    </p>
                                </div>
                                <div v-else-if="(kpiData.err_app||[]).length>0">
                                    <p class="text-color-error font12px mt4" v-if="!isView">
                                        <span class="text-bold">{{kpiData.kpiErrInfo||`存在产品【${actionComparativeField.display_name}】KPI未维护，请维护后重试。`}}</span>
                                        <span class="text-color-primary pointer font12px ml20" @click="toKpiPage">点击立即维护</span>
                                        <span class="text-color-primary pointer font12px ml20" @click="()=>checkKpiData()">已维护,点击刷新</span>
                                    </p>
                                </div>
                                <div v-else-if="(kpiData.err_plan||[]).length>0">
                                    <p class="text-color-error font12px mt4" v-if="!isView">
                                        <span class="text-bold">{{kpiData.kpiErrInfo||`存在包含多个产品的计划，请处理后重试。`}}</span>
                                        <span class="text-color-primary pointer font12px ml20" @click="showKpiPlanInfo(kpiData.err_plan)">查看计划详情</span>
                                        <span class="text-color-primary pointer font12px ml20" @click="()=>checkKpiData()">已处理,点击刷新</span>
                                    </p>
                                </div>
                                <div v-else>
                                    <p class="text-color-error font12px mt4" v-if="!isView">
                                        <span class="text-bold">{{kpiData.kpiErrInfo||`KPI数据异常，请维护后重试。`}}</span>
                                        <span v-if="(kpiData.no_app||[]).length>0" class="text-color-primary pointer font12px ml20" @click="showNoAppInfo(kpiData.no_app)">查看详情</span>
                                        <span class="text-color-primary pointer font12px ml20" @click="()=>checkKpiData()">已处理,点击刷新</span>
                                    </p>
                                </div>
                            </el-form-item>
                        </template>
                    </template>
                    <!--<template v-else>-->
                        <!--<el-form-item v-show="data.monitor_data.data_method=='3'&&data.operator&&isCompleteMonitorRangeTimeType">-->
                            <!--<el-select-->
                                <!--:disabled="isView"-->
                                <!--value="对比固定值"-->
                                <!--v-label="{title:'对比项：',color:'#016FA0'}">-->
                                <!--<el-option label="对比固定值" value="对比固定值"></el-option>-->
                            <!--</el-select>-->
                        <!--</el-form-item>-->
                    <!--</template>-->

                    <el-form-item v-show="((data.comparative_data.field&&data.monitor_data.data_method!='3')||(data.monitor_data.data_method=='3'&&data.operator))&&(curComparativeConfig.condition_type!='text')&&data.monitor_data.condition_type!='text'&&data.monitor_data.field&&isCompleteComparativeRangeTimeType&&isCompleteMonitorRangeTimeType&&!isCompareKpiData">
                        <el-select
                            :value="data.comparison_type"
                            v-label="{title:'对比类型：',color:'#A36717'}"
                            @change="changeComparativeType"
                            :disabled="isView"
                            placeholder="请选择">
                            <!-- 1-固定值，2-百分比 -->
                            <el-option
                                v-for="(value,label) in curMonitorConfig.comparative_type"
                                :key="value"
                                :label="value"
                                :disabled="label==2&&(!data.comparative_data.field||data.comparative_data.field=='-1')"
                                :value="label"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :error="getError('comparison_value')" v-show="((data.comparative_data.field&&data.monitor_data.data_method!='3')||(data.monitor_data.data_method=='3'&&data.operator))&&data.monitor_data.field&&data.comparison_type&&isCompleteMonitorRangeTimeType&&!isCompareKpiData">
                        <template v-if="curMonitorConfig.condition_type!='text'">
                            <el-input-number
                                :value="data.comparison_value"
                                @input="changeComparisonValue"
                                v-label="{title:'对比值：',color:'#A36717'}"
                                :disabled="isView"
                                :controls="false"
                                placeholder="请输入内容"></el-input-number>
                            <span class="ml6 mr10 font12px text-color-normal" v-if="data.comparison_type=='2'">%</span>
                        </template>
                        <template v-else>
                            <el-select
                                key="comparison_value"
                                :value="data.comparison_value"
                                multiple
                                v-label="{title:'选项：',color:'#A36717'}"
                                @change="changeComparisonValue"
                                :loading="data.textOptionLoading"
                                :disabled="isView"
                                placeholder="请选择">
                                <!-- 1-固定值，2-百分比 -->
                                <el-option v-for="(value,label) in data.textOptionList" :label="value" :value="label" :key="value"></el-option>
                            </el-select>
                        </template>
                    </el-form-item>
                    <el-form-item v-if="data.comparative_data.field&&data.monitor_data.condition_type=='data_1'&&data.comparative_data.condition_type=='data_1'&&data.monitor_data.range_time_type=='1'&&!isCompareKpiData">
                        <!-- a.监控1类当日+对比1类：显示【同时段】
                             b.same_time_segment为true:表示支持小时数据
                             c.same_day_segment为true:表示当日可不可用
                             d.监控小时当日+对比小时：可用【同时段】
                         -->
                        <el-checkbox
                            :value="data.same_time_segment"
                            @change="changeSameTimeSegment"
                            :disabled="isView||noSupportHour"
                            true-label="1"
                            false-label="0">同时段</el-checkbox>
                    </el-form-item>
                </div>

                <p class="text-color-error mb10 font12px" v-if="showTip"> <i class="el-icon-warning mr2"></i> 账户预算是不限时，该条件不会被触发</p>

            </el-form>
        </div>
        <div class="remove-btn">
            <span class="text-color-error el-icon-delete-solid pointer" v-if="!isView" @click="remove" title="删除"></span>
        </div>
    </div>
</template>

<script>
    import {cloneDeep,uniq} from 'lodash';
    import API from '@/api/intelligent/intelligentManaged/index.js';
    import {mapState} from 'vuex';
    import {kpiPlanAppModal,kpiNoAppModal} from '../../modal/index';
    import CustomInput from '@/components/CustomInput'

    export default {
        components:{
            CustomInput,
        },
        name: "ConditionItem",
        props:{
            data:{
                type:Object,
                default(){
                    return {
                        monitor_data:{
                            id:'',
                            field:'',
                            range_time_type:'',
                            range_time_n:undefined,
                            range_time_n1:undefined,
                            range_time:[],
                            data_method:'',
                        },
                        comparative_data:{
                            id:'',
                            field:'',
                            data_method:'',
                            range_time_type:'',
                            range_time:[],
                            range_time_n:undefined,
                            range_time_n1:undefined,
                            delivery_scene:'',
                        },
                        operator:'',
                        comparison_type:'',
                        comparison_value:'',
                        same_time_segment:'0',
                    }
                }
            },
            verify:Object,
        },
        inject:['platId','appointed_time','max_range_time','condition_config','conditionOptionList','isView','goalFormData','isEdit'],
        data(){
            return {
                isInit:true,
                deliverySceneMap:{
                    1:'整体',
                    2:'商店-整体',
                    3:'非商店-整体',
                    4:'信息流',
                    5:'联盟',
                },
                kpiLoading:false,
                costTypeList: [
                    {
                        label:'总消耗',
                        value:'cost',
                    },
                    {
                        label:'现金',
                        value:'cash_cost',
                    },
                    {
                        label:'虚拟金',
                        value:'virtual_cost',
                    },
                ]
            };
        },
        mounted(){
            if(this.isView){
                this.isHasKPI = true;
            }else if(this.isEdit||this.isCopy){
                this.isHasKPI = false;
            }
        },
        computed:{
            ...mapState({
                clear_conditions_kpi: state => state.intelligent.clear_conditions_kpi,
                update_conditions_kpi: state => state.intelligent.update_conditions_kpi,
            }),
            plat_id(){
                return this.platId();
            },
            appointedTime(){
                return this.appointed_time();
            },
            maxRangeTime(){
                return +this.max_range_time();
            },
            conditionConfig(){
                return this.condition_config();
            },
            conditionOptions(){
                return this.conditionOptionList();
            },
            monitorConditionOptions(){
                let rawList = cloneDeep(this.conditionOptions);
                return rawList.filter(item=>item.name!='kpi_data');
            },
            goalInfo(){
                return this.goalFormData();
            },
            goalInfoDimension(){
                return this.goalInfo.oldDimension||'';
            },
            goalInfoAppList(){
                return this.goalInfo.dimension_config_data||[];
            },
            isAppDimension(){
                /* 1-账户，2-产品，3-计划/任务，4-创意/子任务 */
                /* 5-所有产品，10-所有计划，16-所有创意 */
                return this.goalInfoDimension&&this.goalInfoDimension!='1'&&(this.goalInfoAppList.length>0||['5','10','16'].includes(this.goalInfo.dimension_config));
            },
            isCompareKpiData(){
                return this.data.comparative_data.condition_type=='kpi_data';
            },
            curMonitorConfig(){
                let activeField = this._findFieldById(this.conditionOptions,this.data.monitor_data.id);
                console.log(6666,activeField,this.data.monitor_data)
                if(!activeField) return {
                    comparative_condition_type:[],
                };
                let config = typeof activeField.config==='string'?JSON.parse(activeField.config):activeField.config||{};
                let conditionSetting = (this.conditionConfig||[]).find(item=>item.condition_type==config.condition_type);
                return {...conditionSetting};
            },
            actionMonitorField(){
                let activeField = this._findFieldById(this.monitorConditionOptions,this.data.monitor_data.id);
                if(!activeField) return {};
                let config = typeof activeField.config==='string'?JSON.parse(activeField.config):activeField.config||{};
                return {
                    name:activeField.name,
                    display_name:activeField.display_name,
                    condition_type:config.condition_type,
                    same_time_segment:!!config.same_time_segment,
                    same_day_segment:!!config.same_day_segment,
                    cost_type:config.cost_type,
                }
            },
            actionComparativeField(){
                let activeField = this._findFieldById(this.conditionOptions,this.data.comparative_data.id);
                if(!activeField) return {};
                let config = typeof activeField.config==='string'?JSON.parse(activeField.config):activeField.config||{};
                return {
                    name:activeField.name,
                    display_name:activeField.display_name,
                    condition_type:config.condition_type,
                    same_time_segment:!!config.same_time_segment,
                    same_day_segment:!!config.same_day_segment,
                    cost_type:config.cost_type,
                }
            },
            comparativeConditionOptions(){
                // let available = [].concat(this.curMonitorConfig.comparative_condition_type||[],this.isAppDimension?'kpi_data':[]);
                let monitorData = this.data.monitor_data||{};
                let conditionType = monitorData.condition_type||'';

                let available = [];
                if(monitorData.data_method=='3'){
                    available = [].concat(conditionType=='data_1'?'kpi_data':'');
                }else{
                    available = [].concat(this.curMonitorConfig.comparative_condition_type||[],conditionType=='data_1'?'kpi_data':'');
                }
                let list =  this._filterConditionsOptions2(cloneDeep(this.conditionOptions),available);
                return [{
                    display_name:'对比固定值',
                    name:'-1',
                    id:'-1',
                    type:'3',
                }].concat(list);
            },
            curComparativeConfig(){
                let activeField = this._findFieldById(this.conditionOptions,this.data.comparative_data.id);
                if(!activeField) return {};
                let config = typeof activeField.config==='string'?JSON.parse(activeField.config):activeField.config||{};
                let conditionSetting = (this.conditionConfig||[]).find(item=>item.condition_type==config.condition_type);
                return {...conditionSetting};
            },
            showTip(){
                return this.data.monitor_data.field=='account_daily_budget'||this.data.comparative_data.field=='account_daily_budget';
            },
            isCompleteMonitorRangeTimeType(){
                if(this.data.monitor_data.condition_type == 'data_1'){
                    if(this.data.monitor_data.range_time_type != '') return true;

                    // if(this.data.monitor_data.range_time_type == '2' && this.data.monitor_data.range_time_n) return true;
                    // if(this.data.monitor_data.range_time_type == '3' && this.data.monitor_data.range_time_n && this.data.monitor_data.range_time_n1) return true;
                    return false;
                }
                /* 二类指标 不需要时间范围 */
                return true;
            },
            isCompleteComparativeRangeTimeType(){
                if(this.data.comparative_data.condition_type == 'data_1'){
                    if(this.data.comparative_data.range_time_type != '') return true;
                    // if(this.data.comparative_data.range_time_type == '2' && this.data.comparative_data.range_time_n) return true;
                    // if(this.data.comparative_data.range_time_type == '3' && this.data.comparative_data.range_time_n && this.data.comparative_data.range_time_n1) return true;
                    return false;
                }
                /* 二类指标 不需要时间范围 */
                return true;
            },
            // 仅仅为了调整顺序
            timeRangeConfigKeys(){
                let config = this.curMonitorConfig.time_range||{};
                return ['1','2','4','3','5','6','7','8','9'].filter(item=>!!config[item]);
            },
            kpiData(){
                return (this.verify||{})[this.data.cid]||{};
            },
            noSupportHour(){
                return this.actionComparativeField.same_time_segment===false || this.actionMonitorField.same_time_segment===false;
            },
        },
        watch: {
            'clear_conditions_kpi'() {
                this.clearConditionsKpi();
            },
            'update_conditions_kpi'(){
                if(this.data.comparative_data.field){
                    this.$nextTick(()=>{
                        this.checkKpiData();
                    })
                }
            },
        },
        methods:{
            changeCostType(val) {
                if(this.actionMonitorField.cost_type){
                    this.$emit('change',this.data,'monitor_data.cost_type',val);
                }else {
                    this.$emit('change',this.data,'monitor_data.cost_type','');
                };
                if(this.actionComparativeField.cost_type) {
                    this.$emit('change',this.data,'comparative_data.cost_type',val);
                }else{
                    this.$emit('change',this.data,'comparative_data.cost_type','');
                }
            },
            remove(){
                if(this.isView) return;
                this.$emit('remove',this.data);
            },
            changeMonitorCondition(val){
                let fieldItem = this._findFieldByName(this.monitorConditionOptions,val)||{};
                let config = fieldItem.config||{};
                this.changeCostType('cost');
                this.$emit('change',this.data,'monitor_data.field',val,fieldItem.id||'',config.condition_type||'');
                if(this.actionMonitorField.condition_type=='text'){
                    this.$emit('check-text',this.data,val)
                }
                if(config.same_time_segment===false){
                    this.$emit('change',this.data,'same_time_segment',false);
                }
            },
            changeMonitorRangeTimeType(val){
                this.$emit('change',this.data,'monitor_data.range_time_type',val);
            },
            changeMonitorRangeTimeN(val){
                this.isInit = false;
                this.$emit('change',this.data,'monitor_data.range_time_n',+val);
            },
            changeMonitorRangeTimeN1(val){
                this.isInit = false;
                this.$emit('change',this.data,'monitor_data.range_time_n1',+val);
            },
            changeMonitorDataMethod(val){
                this.$emit('change',this.data,'monitor_data.data_method',val);
            },
            changeOperator(val){
                this.$emit('change',this.data,'operator',val);
            },
            changeComparativeRangeTimeType(val){
                this.$emit('change',this.data,'comparative_data.range_time_type',val);
            },
            changeComparativeRangeTimeN(val){
                this.isInit = false;
                this.$emit('change',this.data,'comparative_data.range_time_n',+val);
            },
            changeComparativeRangeTimeN1(val){
                this.isInit = false;
                this.$emit('change',this.data,'comparative_data.range_time_n1',+val);
            },
            changeComparativeCondition(val){
                if(val=='-1'){
                    return this.$emit('change',this.data,'comparative_data.field',val,'','');
                }
                let fieldItem = this._findFieldById(this.conditionOptions,val)||{};
                let config = fieldItem.config||{};
                let conditionType = config.condition_type||'';
                this.$nextTick(()=>{
                    if(this.actionMonitorField.cost_type){
                        this.changeCostType(this.data.monitor_data.cost_type);
                    }else if(this.actionComparativeField.cost_type){
                        this.changeCostType('cost');
                    }
                })
                console.log(config, '==============');
                if(conditionType=='kpi_data'){
                    // let oldData = cloneDeep(this.data.comparative_data);
                    if(this.goalInfoDimension&&this.goalInfoDimension=='1'){
                        // 账户
                        this.$message.error('仅目标维度为产品、计划、创意时可对比产品KPI数据');
                        this.$emit('change',this.data,'comparative_data.field',fieldItem.name,fieldItem.id||'',conditionType);
                        this.$nextTick(()=>{
                            // this.$emit('change',this.data,'comparative_data.field',oldData.field,oldData.id||'',oldData.condition_type);
                            this.$emit('change',this.data,'comparative_data.field','','','');
                        })
                    }else if(this.goalInfoAppList.length<=0&&!['5','10','16'].includes(this.goalInfo.dimension_config)){
                        // 5-所有产品，10-所有计划，16-所有创意
                        this.$message.error('请先选择维度筛选');
                        this.$emit('change',this.data,'comparative_data.field',fieldItem.name,fieldItem.id||'',conditionType);
                        this.$nextTick(()=>{
                            // this.$emit('change',this.data,'comparative_data.field',oldData.field,oldData.id||'',oldData.condition_type);
                            this.$emit('change',this.data,'comparative_data.field','','','');
                        })
                    }else{
                        this.checkKpiData({
                            field:fieldItem.name,
                        });
                        this.$emit('change',this.data,'comparative_data.field',fieldItem.name,fieldItem.id||'',conditionType);
                    }
                }else{
                    this.$emit('change',this.data,'comparative_data.field',fieldItem.name,fieldItem.id||'',conditionType);
                }

                if(config.same_time_segment===false||this.noSupportHour){
                    this.$emit('change',this.data,'same_time_segment',false);
                }
            },
            changeComparativeDeliveryScene(val){
                this.$emit('change',this.data,'comparative_data.delivery_scene',val);
                this.checkKpiData({
                    delivery_scene:val,
                });
            },
            changeComparativeDataMethod(val){
                this.$emit('change',this.data,'comparative_data.data_method',val);
            },
            changeComparativeType(val){
                this.$emit('change',this.data,'comparison_type',val);
            },
            changeComparisonValue(val){
                this.isInit = false;
                if(Array.isArray(val)){
                    this.$emit('change',this.data,'comparison_value',val);
                }else{
                    this.$emit('change',this.data,'comparison_value',+val);
                }
            },
            changeSameTimeSegment(val){
                this.$emit('change',this.data,'same_time_segment',val);
            },
            toKpiPage(){
                console.log('toKpiPage',this.kpiData,this.data,this.data.comparative_data.delivery_scene);

                let $router= this.$router.resolve({
                    name:'app_kpi_'+this.plat_id,
                    query:{
                        // app_id:this.kpiData.err_app,
                        query_app:this.data.cid,
                    },
                });
                localStorage.setItem("intelligentRuleApp_"+this.data.cid, JSON.stringify(uniq(this.kpiData.err_app)));

                let route404 = this.$router.resolve({
                    name: '404',
                });
                window.open(($router.href||'').includes('app_kpi_')?$router.href:route404.href, '_blank');
            },
            showKpiPlanInfo(list){
                console.log('showKpiPlanInfo',list);
                kpiPlanAppModal({
                    props:{
                        customClass:'modal-body-padding-top-20',
                        data:{...list},
                        desc:'',
                    },
                    cbs:{
                    },
                })
            },
            showNoAppInfo(list){
                kpiNoAppModal({
                    props:{
                        customClass:'modal-body-padding-top-20',
                        data:{...list},
                        desc:'',
                    },
                    cbs:{
                    },
                })
            },
            checkKpiData(data){
                if(data){
                    if(!data.field&&!data.delivery_scene) return;
                }else{
                    if(this.data.comparative_data.condition_type!='kpi_data') return;
                    if(!this.data.comparative_data.field||!this.data.comparative_data.delivery_scene) return;
                }

                let reqData = {
                    plat_id:this.plat_id,
                    dimension:this.goalInfo.dimension,
                    dimension_config:this.goalInfo.dimension_config,
                    dimension_config_data_id:(this.goalInfo.dimension_config_data||[]).map(item=>item.id).join(),
                };
                if(data?.field){
                    reqData.field = data.field;
                    reqData.delivery_scene = this.data.comparative_data.delivery_scene;
                }else if(data?.delivery_scene){
                    reqData.field = this.data.comparative_data.field;
                    reqData.delivery_scene = data.delivery_scene;
                }else{
                    reqData.field = this.data.comparative_data.field;
                    reqData.delivery_scene = this.data.comparative_data.delivery_scene;
                }

                if(!reqData.field||!reqData.delivery_scene) return;

                this.kpiLoading = true;
                this.isHasKPI = false;
                this.kpiErrData = [];
                API.checkKpiData(reqData).then(res=>{
                    console.log('checkKpiData',res);
                    this.kpiLoading = false;
                    // this.isHasKPI = true;
                    // this.kpiErrData = [];
                    this.$emit('change',this.data,'check_api',{});
                }).catch(err=>{
                    console.log('checkKpiData err',err);
                    this.kpiLoading = false;
                    // this.isHasKPI = false;
                    // this.kpiErrData = err.data||[];
                    this.$emit('change',this.data,'check_api',err);
                })
            },
            clearConditionsKpi(){
                this.changeComparativeCondition('');
            },



            _filterConditionsOptions(data,list){
                let newData = [];
                data.forEach(item=>{
                    let children = item.children||[];
                    let allChildren = [];
                    children.forEach(inner=>{
                        allChildren = allChildren.concat(inner.children||[]);
                    });
                    if(allChildren.some(inner=>{
                        let config = inner.config||{};
                        return list.includes(config.condition_type)
                    })){
                        newData.push(item)
                    }
                });

                newData.forEach(data=>{
                    data.children = data.children.filter(inner=>{
                        let innerChildren = inner.children||[];
                        return innerChildren.some(son=>{
                            let config = son.config||{};
                            return list.includes(config.condition_type)
                        })
                    })
                });
                return newData;
            },
            _filterConditionsOptions2(data,list){
                console.log('_filterConditionsOptions2',data,list);
                let newData = [];
                data.forEach(item=>{
                    let children = item.children||[];
                    if(children.some(inner=>{
                        let config = inner.config||{};
                        return list.includes(config.condition_type)
                    })){
                        newData.push(item)
                    }
                });
                newData.forEach(data=>{
                    data.children = data.children.filter(inner=>{
                        let config = inner.config||{};
                        return list.includes(config.condition_type)
                    })
                });
                return newData;
            },
            _findFieldByName(data, name) {
                for (let item in data) {
                    if (data[item].name == name) {
                        return data[item];
                    } else {
                        let child = data[item].children;
                        if (child && child.length > 0) {
                            let result = this._findFieldByName(child, name);
                            if (result) {
                                return result;
                            }
                        }
                    }
                }
            },
            _findFieldById(data, id) {
                for (let item in data) {
                    if (data[item].id == id) {
                        return data[item];
                    } else {
                        let child = data[item].children;
                        if (child && child.length > 0) {
                            let result = this._findFieldById(child, id);
                            if (result) {
                                return result;
                            }
                        }
                    }
                }
            },
            countDecimalPlaces(num){
                const numStr = ''+num;
                const decimalIndex = numStr.indexOf('.');
                if (decimalIndex === -1) {
                    return 0;
                }
                return numStr.length - decimalIndex - 1;
            },
            getError(field){
                if(this.isInit) return '';
                if(field=='comparison_value'){
                    let val = +this.data.comparison_value;
                    console.log('getError',field,val);
                    if(val<0) return '不可为负数';
                    if(!!val&&this.countDecimalPlaces(val)>2) return '最多支持2位小数';
                    return ''
                }else if(field=='monitor_data.range_time'){
                    let num = +this.data.monitor_data.range_time_n;
                    let num1 = +this.data.monitor_data.range_time_n1;
                    if(num<0||num1<0)  return '请输入大于0的整数';
                    if(num>this.maxRangeTime||num1>this.maxRangeTime) return '最多支持'+this.maxRangeTime+'天';
                    if(this.countDecimalPlaces(num)>0||this.countDecimalPlaces(num1)>0)  return '天数不能为小数';
                    return '';
                }else if(field=='comparative_data.range_time'){
                    let num = +this.data.comparative_data.range_time_n;
                    let num1 = +this.data.comparative_data.range_time_n1;
                    if(num<0||num1<0)  return '请输入大于0的整数';
                    if(num>this.maxRangeTime||num1>this.maxRangeTime) return '最多支持'+this.maxRangeTime+'天';
                    if(this.countDecimalPlaces(num)>0||this.countDecimalPlaces(num1)>0)  return '天数不能为小数';
                    return '';
                }
                return '';
            },
        },
    }
</script>

<style lang="scss" scoped>
    .condition-item {
        min-height: 50px;
        padding: 20px 20px 0;
        border: solid 1px #d3d3d3;
        margin-bottom: 10px;
        position: relative;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);;
        &::v-deep(.append){
            padding: 0;
        }
        .remove-btn{
            position: absolute;
            right: 10px;
            top: 10px;
        }

        .normal-text,.text-normal{
            color: #606266;
            font-size: 12px;
        }
    }
</style>
